define('presentation/inbox/facades/inboxSidebarFacade',['businessServices/userSettings/userSettingStore',
        'common/time/datetimeFormatter'
    ], function () {
        const DateTimeFormatterConstructor = require('common/time/datetimeFormatter');
        const _dateTimeFormatter = new DateTimeFormatterConstructor();

        let _promiseFactory = null;
        let _userSettingStore = null;

        const DEFAULT_SETTINGS = {
            selectedShowFilter: 'all',
            selectedTimeframeFilter: '',
            timeframeCustomStartOn: '',
            timeframeCustomEndOn: '',
        };

        const _formatCustomDateTextToIso = (customDateTimeText) => {
            if (customDateTimeText) {
                return _dateTimeFormatter.customDateTimeTextToIso(customDateTimeText, 'MM/DD/YYYY hh:mm a');
            }

            return '';
        };
        const _formatCustomDateTextFromIso = (customDateTimeIso) => {
            if (customDateTimeIso) {
                return _dateTimeFormatter.customDateTimeTextFromIso(customDateTimeIso, 'MM/DD/YYYY hh:mm a');
            }

            return '';
        };

        const _getSetting = (value, defaultValue) => {
            return (value === undefined || value === null) ? defaultValue : value;
        };

        const _getCallRecordingSidebarSettings = () => {
            return _promiseFactory.deferIndefinitely((promise) => {
                _userSettingStore.get("callRecordingSidebar")
                    .fail(promise.reject)
                    .done((sidebarSettings) => {
                        const settings = {
                            selectedShowFilter: _getSetting(sidebarSettings.selectedNewReviewedFilter, DEFAULT_SETTINGS.selectedShowFilter),
                            selectedTimeframeFilter: _getSetting(sidebarSettings.selectedTimeframeFilter, DEFAULT_SETTINGS.selectedTimeframeFilter),
                            timeframeCustomStartOn: _formatCustomDateTextFromIso(_getSetting(sidebarSettings.timeframeCustomStartOn, DEFAULT_SETTINGS.timeframeCustomStartOn)),
                            timeframeCustomEndOn: _formatCustomDateTextFromIso(_getSetting(sidebarSettings.timeframeCustomEndOn, DEFAULT_SETTINGS.timeframeCustomEndOn)),
                        };
                        promise.resolve(settings);
                    });
            });
        };

        const _getVoicemailSidebarSettings = () => {
            return _promiseFactory.deferIndefinitely((promise) => {
                _userSettingStore.get("voicemailSidebar")
                    .fail(promise.reject)
                    .done((sidebarSettings) => {
                        const settings = {
                            selectedShowFilter: _getSetting(sidebarSettings.selectedNewReviewedFilter, DEFAULT_SETTINGS.selectedShowFilter),
                            selectedTimeframeFilter: _getSetting(sidebarSettings.selectedTimeframeFilter, DEFAULT_SETTINGS.selectedTimeframeFilter),
                            timeframeCustomStartOn: _formatCustomDateTextFromIso(_getSetting(sidebarSettings.timeframeCustomStartOn, DEFAULT_SETTINGS.timeframeCustomStartOn)),
                            timeframeCustomEndOn: _formatCustomDateTextFromIso(_getSetting(sidebarSettings.timeframeCustomEndOn, DEFAULT_SETTINGS.timeframeCustomEndOn)),
                        };
                        promise.resolve(settings);
                    });
            });
        };

        const _saveCallRecordingSidebarSettings = (sidebarSettings) => {
            return _promiseFactory.deferIndefinitely((promise) => {
                const settings = {
                    selectedNewReviewedFilter: _getSetting(sidebarSettings.selectedShowFilter, DEFAULT_SETTINGS.selectedShowFilter),
                    selectedTimeframeFilter: _getSetting(sidebarSettings.selectedTimeframeFilter, DEFAULT_SETTINGS.selectedTimeframeFilter),
                    timeframeCustomStartOn: _formatCustomDateTextToIso(_getSetting(sidebarSettings.timeframeCustomStartOn, DEFAULT_SETTINGS.timeframeCustomStartOn)),
                    timeframeCustomEndOn: _formatCustomDateTextToIso(_getSetting(sidebarSettings.timeframeCustomEndOn, DEFAULT_SETTINGS.timeframeCustomEndOn))
                };
                _userSettingStore.set("callRecordingSidebar", settings)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const _saveVoicemailSidebarSettings = (sidebarSettings) => {
            return _promiseFactory.deferIndefinitely((promise) => {
                const settings = {
                    selectedNewReviewedFilter: _getSetting(sidebarSettings.selectedShowFilter, DEFAULT_SETTINGS.selectedShowFilter),
                    selectedTimeframeFilter: _getSetting(sidebarSettings.selectedTimeframeFilter, DEFAULT_SETTINGS.selectedTimeframeFilter),
                    timeframeCustomStartOn: _formatCustomDateTextToIso(_getSetting(sidebarSettings.timeframeCustomStartOn, DEFAULT_SETTINGS.timeframeCustomStartOn)),
                    timeframeCustomEndOn: _formatCustomDateTextToIso(_getSetting(sidebarSettings.timeframeCustomEndOn, DEFAULT_SETTINGS.timeframeCustomEndOn))
                };
                _userSettingStore.set("voicemailSidebar", settings)
                    .fail(promise.reject)
                    .done(promise.resolve);
            });
        };

        const init = function (promiseFactory) {
            _promiseFactory = promiseFactory;

            const UserSettingStoreConstructor = require('businessServices/userSettings/userSettingStore');
            _userSettingStore = new UserSettingStoreConstructor();
            _userSettingStore.init();
        };

        return function () {
            let self = this;

            self.init = init;
            self.getCallRecordingSidebarSettings = _getCallRecordingSidebarSettings;
            self.saveCallRecordingSidebarSettings = _saveCallRecordingSidebarSettings;
            self.getVoicemailSidebarSettings = _getVoicemailSidebarSettings;
            self.saveVoicemailSidebarSettings = _saveVoicemailSidebarSettings;
           };
    }
);
